module.exports = __webpack_public_path__ + "static/media/allergies.fa8f4e24.svg";